import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { paths } from '@/shared/routes/paths';
import type { RouteHandle } from '@/shared/routes/route-handle';

const Login = lazy(() => import('@/features/auth/login'));
const ForgotPassword = lazy(() => import('@/features/auth/forgot-password'));
const ResetPassword = lazy(() => import('@/features/auth/reset-password'));
const ConfirmEmailChange = lazy(() => import('@/features/auth/confirm-email-change'));
const Onboarding = lazy(() => import('@/features/auth/onboarding'));

/**
 * Public zone: reachable without authentication. Rendered as bare <Route>
 * elements (not a component) so React Router's `createRoutesFromElements` can
 * see them when this fragment is inlined into the route tree.
 *
 * `handle` carries each page's title (see RouteHandle). These pages render
 * outside the AppLayout, so the title only reaches the browser tab.
 */
export const publicRoutes = (
  <>
    <Route
      path={paths.login}
      element={<Login />}
      handle={{ title: 'Sign In' } satisfies RouteHandle}
    />
    <Route
      path={paths.forgotPassword}
      element={<ForgotPassword />}
      handle={{ title: 'Forgot Password' } satisfies RouteHandle}
    />
    <Route
      path={paths.resetPassword}
      element={<ResetPassword />}
      handle={{ title: 'Reset Password' } satisfies RouteHandle}
    />
    <Route
      path={paths.confirmEmailChange}
      element={<ConfirmEmailChange />}
      handle={{ title: 'Confirm Email Change' } satisfies RouteHandle}
    />
    <Route
      path={paths.onboarding}
      element={<Onboarding />}
      handle={{ title: 'Set Up Your Account' } satisfies RouteHandle}
    />
  </>
);
